import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import type { IAuthTokens } from '@web/entities/user'
import {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY
} from '@web/entities/user/model/token-key.constant'
import { EAuthStatus } from '@web/shared/enums/auth/auth-status.enum'
import { useDispatchedActions } from '@web/shared/hooks/use-dispatched-actions.hook'

export interface IAuthState {
  authStatus: EAuthStatus
  accessToken: string | null
  refreshToken: string | null
}

const initialState: IAuthState = {
  authStatus: EAuthStatus.PENDING,
  accessToken: localStorage.getItem(ACCESS_TOKEN_KEY),
  refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY)
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthorized: (state) => {
      state.authStatus = EAuthStatus.AUTHORIZED
    },

    setTokens: (state, actions: PayloadAction<IAuthTokens>) => {
      const { accessToken, refreshToken } = actions.payload
      state.accessToken = accessToken
      state.refreshToken = refreshToken

      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
      localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },
    setLogout: (state) => {
      state.authStatus = EAuthStatus.UNAUTHORIZED
      localStorage.removeItem(ACCESS_TOKEN_KEY)
      localStorage.removeItem(REFRESH_TOKEN_KEY)
    }
  }
})

export const authReducer = authSlice.reducer
export const { setAuthorized, setLogout, setTokens } = authSlice.actions
export const useAuthActions = () => useDispatchedActions(authSlice.actions)
